var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHourglassDisabled = function SvgHourglassDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m791-57-24-23H200q-17 0-28.5-11.5T160-120t11.5-28.5T200-160h40v-120q0-61 28.5-114.5T348-480q-32-20-54.5-48T257-590L55-792q-12-12-12-28.5T55-849t28.5-12 28.5 12l736 736q12 12 12 28t-12 28-28.5 12T791-57M602-474l-60-59q45-19 71.5-59t26.5-88v-120H320v45l-45-45-80-80h565q17 0 28.5 11.5T800-840t-11.5 28.5T760-800h-40v120q0 64-31 119t-87 87M320-160h320v-47L419-428q-45 19-72 59t-27 89zm400 0"
  })));
};
export default SvgHourglassDisabled;